import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center">
                <span className="text-black font-bold text-2xl">G</span>
              </div>
              <div>
                <h4 className="text-xl font-bold text-yellow-400">GUS GROUP LTD</h4>
                <p className="text-xs text-gray-400">Excellence in Construction</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              Ghana's premier construction and real estate company, delivering world-class solutions with excellence and integrity.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://facebook.com/gusgroupltd" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com/gusgroupltd"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com/company/gusgroupltd"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/about" className="hover:text-yellow-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-yellow-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="hover:text-yellow-400 transition-colors">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-yellow-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-yellow-400 font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                <a 
                  href="https://maps.google.com/?q=Nii+Afutu+Tsuru+St+Accra"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition-colors"
                >
                  Opposite HGL Guest House<br />Nii Afutu Tsuru St, Accra
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-yellow-400" />
                <a 
                  href="tel:0592668258"
                  className="hover:text-yellow-400 transition-colors"
                >
                  0592668258
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-yellow-400" />
                <a 
                  href="mailto:info@gusgroupltd.com"
                  className="hover:text-yellow-400 transition-colors"
                >
                  info@gusgroupltd.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
          <p>&copy; 2026 GUS Group Ltd. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="hover:text-yellow-400 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="hover:text-yellow-400 transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;